import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-pdf',
  templateUrl: './icon-pdf.component.html',
  styleUrls: ['./icon-pdf.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPdfComponent {}
